import React from "react";
import { Section, SerifH, Eyebrow, PrimaryButton, Bullet, Card } from "../components/ui-kit/Primitives";

const services = [
  "One-on-one peer support",
  "Recovery support",
  "Mental health wellness support",
  "Substance use recovery support",
  "Life skills development",
  "Community resource navigation",
  "Goal planning",
  "Crisis prevention support",
  "Family support and education",
  "Re-entry and transition support",
  "Employment readiness support",
  "Housing stability support",
  "Wellness planning",
  "Group peer support",
  "Community workshops",
];

const served = [
  "Individuals seeking emotional and recovery support",
  "Adults navigating mental health or substance use recovery",
  "Families needing guidance and resources",
  "Justice-involved individuals returning to the community",
  "Individuals seeking stability, structure, and accountability",
  "Community members needing support with life transitions",
];

const img = "https://images.unsplash.com/photo-1573164713619-24c711fe7878?auto=format&fit=crop&w=1400&q=80";

const PeerSupport = () => (
  <div data-testid="peer-support-page">
    <Section className="pt-16">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
        <div className="lg:col-span-7">
          <Eyebrow>Peer Support Services</Eyebrow>
          <SerifH as="h1" className="text-5xl sm:text-6xl">
            Peer support rooted in lived experience, hope, and community wellness.
          </SerifH>
        </div>
        <div className="lg:col-span-5 text-slate-600 font-light leading-relaxed">
          <p>
            KBX Pathways To Wellness is preparing to provide peer support services designed to help
            individuals navigate recovery, emotional wellness, life transitions, and community
            reintegration — with support from people who understand the journey.
          </p>
          <p className="mt-4">
            Our peer support model is built on compassion, accountability, advocacy, and practical guidance.
          </p>
          <div className="mt-5 inline-flex items-center gap-2 text-xs tracking-[0.22em] uppercase text-brand-gold bg-brand-gold/10 border border-brand-gold/30 rounded-full px-4 py-2">
            Upcoming Service Area
          </div>
        </div>
      </div>
      <div className="mt-12 rounded-[2rem] overflow-hidden border border-brand-green/10">
        <img src={img} alt="Peer support" className="w-full h-[360px] sm:h-[460px] object-cover" />
      </div>
    </Section>

    <Section className="bg-brand-mist/50">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <Eyebrow>What we will offer</Eyebrow>
          <SerifH className="text-4xl sm:text-5xl">Planned peer support services.</SerifH>
        </div>
        <div className="lg:col-span-7">
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-8">
            {services.map((s) => <Bullet key={s}>{s}</Bullet>)}
          </ul>
        </div>
      </div>
    </Section>

    <Section>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <Card className="lg:col-span-7 p-10">
          <Eyebrow>Who we serve</Eyebrow>
          <SerifH as="h3" className="text-3xl">Built for the people closest to the work.</SerifH>
          <ul className="mt-6 space-y-3">
            {served.map((s) => <Bullet key={s}>{s}</Bullet>)}
          </ul>
        </Card>
        <Card className="lg:col-span-5 bg-brand-green text-white border-brand-green p-10">
          <Eyebrow color="gold">Our philosophy</Eyebrow>
          <SerifH as="h3" className="text-3xl text-white">Walking beside, not in front of.</SerifH>
          <p className="mt-5 text-slate-200 leading-relaxed font-light">
            Peer support is not about judgment. It is about walking beside someone, helping them
            recognize their strengths, and supporting them as they build a healthier, more stable life.&nbsp;
          </p>
        </Card>
      </div>
    </Section>

    <Section className="bg-brand-navy text-white">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-8">
          <SerifH className="text-4xl sm:text-5xl text-white">
            Support, structure, and hope for the journey ahead.
          </SerifH>
        </div>
        <div className="lg:col-span-4 lg:text-right">
          <PrimaryButton to="/contact" testid="peer-cta" className="bg-brand-gold text-brand-navy hover:bg-white">
            Contact Us
          </PrimaryButton>
        </div>
      </div>
    </Section>
  </div>
);

export default PeerSupport;
